import { t } from "@/i18n-js/instance";
import { IconButton } from "@/react/components/shared/uikit/HeaderV3/IconButton";
import { useRailbar } from "@circle-react/hooks/chatsV2";
import { TippyV2 } from "@circle-react-shared/TippyV2";

export const ChatRoomMessageSearchButton = () => {
  const { toggleChatRoomMessageSearchRailbar, isDmsPage } = useRailbar();

  return (
    <TippyV2
      interactive={false}
      content={t("chat_space.header.search_messages")}
    >
      <IconButton
        iconSize={20}
        buttonSize={isDmsPage ? 24 : 36}
        name="20-search-v3"
        ariaLabel={t("chat_space.header.search_messages")}
        className={isDmsPage ? "!rounded-md" : "rounded-lg"}
        iconClassName={isDmsPage ? "!text-dark" : ""}
        onClick={toggleChatRoomMessageSearchRailbar}
      />
    </TippyV2>
  );
};
